import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

// Teach tailwind-merge the app's token names so e.g. `text-fg-2` and `text-sm` don't collide.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: [
        'bg',
        'bg-raised',
        'surface',
        'surface-2',
        'glass',
        'sheet',
        'scrim',
        'field',
        'chip',
        'hairline',
        'hairline-strong',
        'fg',
        'fg-2',
        'fg-3',
        'accent',
        'on-accent',
        'link',
        'focus',
        'success',
        'danger',
        'on-danger',
        'warning',
        'info',
        'success-bg',
        'danger-bg',
        'warning-bg',
        'info-bg',
        'mint',
        'cyan',
        'magenta',
        'yellow',
      ],
      radius: ['xs', 'sm', 'md', 'lg', 'xl', 'pill'],
      font: ['display', 'text', 'mono'],
    },
  },
})

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))
